import { lazy, Suspense } from 'react';
import { Loader } from 'lucide-react';

const RegisterBusiness = lazy(() => import('../../pages/RegisterBusinessDynamicV2'));

const AddEntity = ({ userData }) => {
  return (
    <Suspense fallback={<div className="flex justify-center py-12"><Loader className="w-8 h-8 text-green-400 animate-spin" /></div>}>
      <RegisterBusiness userData={userData} />
    </Suspense>
  );
};

export default AddEntity;
